
  import { defineComponent } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import { TFilterSelect, TFilterTreeSelect } from '@/common/components/redesigned/Filter/types/filter';
  import { MenuModes } from '@/common/components/redesigned/TreeMultiselect/types';
  import constants from '@/common/constants';
  import { TDictionary } from '@/common/types/dictionary';
  import { TPublicNavigationMenu } from '@/common/types/menu';
  import { TDictionaryArrayAxiosResponse } from '@/common/types/response';

  import API_ORG from '../../../api/organization';
  import { TStatisticsPublicFilter } from '../../../types/statistics/statistics-public';
  import StatisticsFilter from '../StatisticsFilter.vue';

  import { DIRECTIVES_ACTIONS_NAME, DIRECTIVES_GETTERS_NAME } from '@/store/directives';

  const UNAUTHORIZED_ORGANIZATION_ID = 0;
  const UNAUTHORIZED_ORGANIZATION_OPTION_ID = -1;

  export default defineComponent({
    name: 'StatisticsPublicFilter',
    components: { StatisticsFilter },
    emits: {
      searchFilter: (value: TStatisticsPublicFilter) => value !== undefined,
    },
    data(): {
      organizations: TDictionary[];
      isOrganizationsLoading: boolean;
    } {
      return {
        organizations: [],
        isOrganizationsLoading: false,
      };
    },
    created() {
      this.getPublicNavigationMenu();
      this.getOrganizations();
    },
    computed: {
      ...mapGetters({
        menu: DIRECTIVES_GETTERS_NAME.getPublicNavigationMenu,
      }),
      getFiltersConfig(): [TFilterSelect<TDictionary>, TFilterTreeSelect<TPublicNavigationMenu>] {
        return [
          {
            type: 'select',
            label: 'Организация',
            placeholder: 'Все',
            options: this.organizations,
            valueProp: 'id',
            labelProp: 'name',
            vModel: 'organizationId',
            clearable: true,
            loadingList: this.isOrganizationsLoading,
          },
          {
            type: 'tree-select',
            label: 'Подсистема/Страница',
            options: this.menu,
            valueProp: 'id',
            labelProp: 'name',
            childrenProp: 'submenu',
            vModel: 'sectionId',
            isSingleMode: true,
            placeholder: 'Все',
            menuMode: MenuModes.NONE,
          },
        ];
      },
    },
    methods: {
      ...mapActions({
        getPublicNavigationMenu: DIRECTIVES_ACTIONS_NAME.getPublicNavigationMenu,
      }),
      searchFilter(filter: TStatisticsPublicFilter) {
        const mappedFilter =
          filter.organizationId === UNAUTHORIZED_ORGANIZATION_OPTION_ID
            ? { ...filter, organizationId: UNAUTHORIZED_ORGANIZATION_ID }
            : filter;

        this.$emit('searchFilter', mappedFilter);
      },
      async getOrganizations() {
        this.isOrganizationsLoading = true;

        try {
          const response: TDictionaryArrayAxiosResponse = await API_ORG.search(constants.paramsFullListDefault);
          this.organizations = [
            { id: UNAUTHORIZED_ORGANIZATION_OPTION_ID, name: 'Неавторизованные' },
            ...response.data.items,
          ];
        } finally {
          this.isOrganizationsLoading = false;
        }
      },
    },
  });
